// /opt/dashboard/frontend/src/pages/UserActivity.js
// Patch 398b — User Activity with IAP purchase display

import React, { useState } from 'react';
import api from '../api';

const C = {
  bg: '#1a1d27', panel: '#22252f', border: '#2a2e3a', text: '#e0e6ed',
  muted: '#8892a0', accent: '#00d4ff', warning: '#fbbf24', danger: '#ef4444',
  success: '#22c55e', purple: '#a855f7',
};

const inputStyle = {
  padding: '8px 10px', background: C.bg, border: '1px solid ' + C.border,
  borderRadius: 4, color: C.text, fontSize: 13, fontFamily: 'inherit',
};

const btnStyle = function(variant) {
  return {
    padding: '8px 14px', border: 'none', borderRadius: 4, cursor: 'pointer',
    fontSize: 13, fontWeight: 500,
    background: variant === 'primary' ? C.accent : C.border,
    color: variant === 'primary' ? '#000' : C.text,
  };
};

function formatDate(iso) {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('hu-HU', { dateStyle: 'short', timeStyle: 'medium' }); }
  catch (e) { return iso; }
}

function sourceLabel(s) {
  var map = {
    consume: '🎧 Narráció', iap_starter: '💳 Starter', iap_explorer: '💳 Explorer',
    iap_traveler: '💳 Traveler', purchase: '💳 Vásárlás', subscription: '🔄 Előfizetés',
    comped_monthly: '🎁 Comped', daily_discovery: '🎁 Napi bónusz',
    referral_bonus: '🤝 Ajánlási bónusz', admin_grant: '🛠️ Admin jóváírás',
  };
  if (s && s.startsWith('promo_')) return '🎟️ Promo: ' + s.replace('promo_', '');
  return map[s] || s || '—';
}

function Field(props) {
  return (
    <div style={{ marginBottom: 8 }}>
      <div style={{ fontSize: 11, color: C.muted, marginBottom: 2 }}>{props.label}</div>
      <div style={{ fontSize: 13, color: C.text }}>{props.value != null ? props.value : '—'}</div>
    </div>
  );
}

export default function UserActivity() {
  var _s = useState(''), query = _s[0], setQuery = _s[1];
  var _l = useState(false), loading = _l[0], setLoading = _l[1];
  var _d = useState(null), data = _d[0], setData = _d[1];
  var _e = useState(null), error = _e[0], setError = _e[1];

  // 🆕 Időszakos lista mód
  var _m = useState('user'), mode = _m[0], setMode = _m[1]; // 'user' | 'interval'
  var _days = useState(30), days = _days[0], setDays = _days[1];
  var _from = useState(''), fromDate = _from[0], setFromDate = _from[1];
  var _to = useState(''), toDate = _to[0], setToDate = _to[1];
  var _ll = useState(false), listLoading = _ll[0], setListLoading = _ll[1];
  var _list = useState(null), list = _list[0], setList = _list[1];
  var _le = useState(null), listError = _le[0], setListError = _le[1];

  // 🆕 POI jóváírás
  var _ga = useState(5), grantAmount = _ga[0], setGrantAmount = _ga[1];
  var _gn = useState(''), grantNote = _gn[0], setGrantNote = _gn[1];
  var _gg = useState(false), granting = _gg[0], setGranting = _gg[1];
  var _gm = useState(null), grantMsg = _gm[0], setGrantMsg = _gm[1];
  var _ge = useState(null), grantErr = _ge[0], setGrantErr = _ge[1];

  // 🆕 User 360 export (xlsx)
  var _xd = useState(30), exportDays = _xd[0], setExportDays = _xd[1];
  var _xt = useState(true), exportTrace = _xt[0], setExportTrace = _xt[1];
  var _xb = useState(null), exportBusy = _xb[0], setExportBusy = _xb[1]; // null | 'preview' | 'download'
  var _xp = useState(null), exportPreview = _xp[0], setExportPreview = _xp[1];
  var _xm = useState(null), exportMsg = _xm[0], setExportMsg = _xm[1];

  // Mennyi adat van — letöltés előtti gyors becslés
  var loadExportPreview = async function() {
    if (!data) return;
    setExportBusy('preview'); setExportMsg(null); setExportPreview(null);
    try {
      var r = await fetch('/api/user-export/preview?uid=' + encodeURIComponent(data.uid) + '&days=' + exportDays,
        { credentials: 'include' });
      var j = await r.json();
      if (!r.ok) throw new Error(j.error || ('HTTP ' + r.status));
      setExportPreview(j);
    } catch (e) {
      setExportMsg({ ok: false, text: e.message });
    } finally {
      setExportBusy(null);
    }
  };

  // A teljes .xlsx letöltése (blobként, hogy a hibaüzenet is látszódjon)
  var downloadExport = async function() {
    if (!data) return;
    setExportBusy('download'); setExportMsg(null);
    try {
      var url = '/api/user-export/full?uid=' + encodeURIComponent(data.uid) +
        '&days=' + exportDays + '&trace=' + (exportTrace ? '1' : '0');
      var r = await fetch(url, { credentials: 'include' });
      if (!r.ok) {
        var msg = 'HTTP ' + r.status;
        try { var j = await r.json(); if (j.error) msg = j.error; } catch (e2) { /* nem JSON */ }
        throw new Error(msg);
      }
      var blob = await r.blob();
      var a = document.createElement('a');
      var objUrl = URL.createObjectURL(blob);
      a.href = objUrl;
      var who = (data.auth && data.auth.email ? data.auth.email : data.uid).replace(/[^a-zA-Z0-9._-]/g, '_');
      a.download = 'user_360_' + who + '_' + exportDays + 'nap.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objUrl);
      setExportMsg({ ok: true, text: 'Letöltés elindult.' });
    } catch (e) {
      setExportMsg({ ok: false, text: e.message });
    } finally {
      setExportBusy(null);
    }
  };

  // 🆕 User törlés — visszafordíthatatlan, ezért előnézet + email-megerősítés
  var _dp = useState(null), delPreview = _dp[0], setDelPreview = _dp[1];
  var _dc = useState(''), delConfirm = _dc[0], setDelConfirm = _dc[1];
  var _db_ = useState(false), delBusy = _db_[0], setDelBusy = _db_[1];
  var _de = useState(null), delErr = _de[0], setDelErr = _de[1];
  var _dd = useState(null), delDone = _dd[0], setDelDone = _dd[1];

  // Mit érint a törlés? — csak lekérdez, nem töröl
  var loadDeletePreview = async function () {
    if (!data) return;
    setDelBusy(true); setDelErr(null); setDelDone(null);
    try {
      var r = await api.userActivity.deletePreview(data.uid);
      setDelPreview(r);
      setDelConfirm('');
    } catch (e) {
      setDelErr(e.message);
    } finally {
      setDelBusy(false);
    }
  };

  var doDeleteUser = async function () {
    if (!data || !delPreview) return;
    var expect = delPreview.email || delPreview.uid;
    if (delConfirm.trim().toLowerCase() !== String(expect).toLowerCase()) {
      setDelErr('A beírt szöveg nem egyezik: ' + expect);
      return;
    }
    if (!window.confirm(
      'VÉGLEGES TÖRLÉS\n\n' + expect + '\n\n' +
      'Törlődik: a bejelentkezési fiók, a user dokumentum, ' +
      delPreview.willDelete.poiTransactions + ' POI-tranzakció és ' +
      delPreview.willDelete.iapTransactions + ' vásárlási rekord.\n\n' +
      'Ez NEM vonható vissza. Biztos vagy benne?')) return;

    setDelBusy(true); setDelErr(null);
    try {
      var r = await api.userActivity.deleteUser(data.uid, delConfirm.trim());
      setDelDone(r);
      setDelPreview(null);
      setData(null); // a user már nem létezik — a panel bezárul
    } catch (e) {
      setDelErr(e.message);
    } finally {
      setDelBusy(false);
    }
  };

  // 🆕 Sprint 4: fuzzy search suggestions
  var _sg = useState([]), suggestions = _sg[0], setSuggestions = _sg[1];
  var _sb = useState(false), searchBusy = _sb[0], setSearchBusy = _sb[1];
  // 🆕 Notes
  var _n = useState([]), notes = _n[0], setNotes = _n[1];
  var _nb = useState(false), noteBusy = _nb[0], setNoteBusy = _nb[1];
  var _ne = useState(''), newNote = _ne[0], setNewNote = _ne[1];
  // 🆕 Direct push
  var _pt = useState(''), pushTitle = _pt[0], setPushTitle = _pt[1];
  var _pb = useState(''), pushBody = _pb[0], setPushBody = _pb[1];
  var _pa = useState(''), pushAction = _pa[0], setPushAction = _pa[1];
  var _pp = useState(false), pushBusy = _pp[0], setPushBusy = _pp[1];
  var _pm = useState(null), pushMsg = _pm[0], setPushMsg = _pm[1];

  var grantPoi = async function () {
    if (!data || !grantAmount) return;
    setGranting(true); setGrantMsg(null); setGrantErr(null);
    try {
      var r = await api.userActivity.grantPoi({ uid: data.uid, amount: grantAmount, note: grantNote.trim() });
      setGrantMsg('✅ Jóváírva. Új egyenleg: ' + r.newBalance + ' POI');
      setGrantNote('');
      lookup({ uid: data.uid }); // frissítés: egyenleg + tranzakciók
    } catch (err) {
      setGrantErr(err.message || 'Hiba');
    } finally {
      setGranting(false);
    }
  };

  // 🆕 Induláskor: az utolsó user-keresés visszatöltése
  React.useEffect(function () {
    try {
      var raw = localStorage.getItem('ua_last');
      if (raw) {
        var p = JSON.parse(raw);
        if (p && (p.uid || p.email)) {
          setQuery(p.uid || p.email);
          lookup(p);
        }
      }
    } catch (e) { /* noop */ }
  }, []);

  var lookup = async function (params) {
    setLoading(true); setError(null); setData(null);
    setNotes([]); setPushMsg(null);
    try {
      var j = await api.userActivity.lookup(params);
      setData(j);
      // 🆕 utolsó keresés megjegyzése (visszatéréskor auto-visszatöltés)
      try { localStorage.setItem('ua_last', JSON.stringify(params)); } catch (e) {}
      // 🆕 Jegyzetek betöltése
      if (j && j.uid) {
        api.userActivity.notes.list(j.uid).then(function(r) { setNotes(r.notes || []); }).catch(function(){});
      }
    } catch (err) {
      setError(err.message || 'Hiba történt');
    } finally {
      setLoading(false);
    }
  };

  // 🆕 Fuzzy email keresés debounce-szal
  var doFuzzySearch = async function (q) {
    if (q.length < 2) { setSuggestions([]); return; }
    setSearchBusy(true);
    try {
      var r = await api.userActivity.searchEmail(q);
      setSuggestions(r.results || []);
    } catch (e) { setSuggestions([]); }
    finally { setSearchBusy(false); }
  };
  // debouncing useEffect helyett egyszerű timer ref
  var _qt = React.useRef(null);
  var onQueryChange = function(v) {
    setQuery(v);
    if (_qt.current) clearTimeout(_qt.current);
    if (v.includes('@') && v.length >= 3 && !v.includes(' ')) {
      // csak akkor fuzzy, ha email formátum, de még nem teljes
      _qt.current = setTimeout(function(){ doFuzzySearch(v); }, 400);
    } else {
      setSuggestions([]);
    }
  };

  // 🆕 Note hozzáadás
  var addNote = async function() {
    if (!data || !newNote.trim()) return;
    setNoteBusy(true);
    try {
      await api.userActivity.notes.add(data.uid, newNote.trim());
      var r = await api.userActivity.notes.list(data.uid);
      setNotes(r.notes || []);
      setNewNote('');
    } catch (e) { /* csendes */ }
    finally { setNoteBusy(false); }
  };
  var delNote = async function(noteId) {
    if (!data) return;
    if (!window.confirm('Biztos törlöd?')) return;
    try {
      await api.userActivity.notes.del(data.uid, noteId);
      var r = await api.userActivity.notes.list(data.uid);
      setNotes(r.notes || []);
    } catch (e) {}
  };

  // 🆕 Direct push küldés
  var sendDirectPush = async function() {
    if (!data || !pushTitle.trim() || !pushBody.trim()) return;
    setPushBusy(true); setPushMsg(null);
    try {
      var r = await api.userActivity.directPush(data.uid, {
        title: pushTitle.trim(), body: pushBody.trim(), action: pushAction.trim() || undefined
      });
      setPushMsg('✅ Elküldve. Sikeres: ' + r.successCount + ' / ' + r.tokenCount + (r.failureCount > 0 ? ', sikertelen: ' + r.failureCount : ''));
      setPushTitle(''); setPushBody(''); setPushAction('');
    } catch (e) {
      setPushMsg('❌ ' + (e.message || 'hiba'));
    } finally { setPushBusy(false); }
  };

  var handleSearch = function (e) {
    if (e) e.preventDefault();
    if (!query.trim()) return;
    setGrantMsg(null); setGrantErr(null);
    var isEmail = query.includes('@');
    var params = {};
    params[isEmail ? 'email' : 'uid'] = query.trim();
    lookup(params);
  };

  // 🆕 Időszakos listázás
  var handleListActive = async function (e) {
    if (e) e.preventDefault();
    setListLoading(true); setListError(null); setList(null);
    try {
      var args = { limit: 200 };
      // ha van egyedi dátumtartomány, az felülírja a "napok" gyorsválasztót
      if (fromDate || toDate) {
        if (fromDate) args.from = new Date(fromDate).toISOString();
        if (toDate) args.to = new Date(toDate + 'T23:59:59').toISOString();
      } else {
        args.days = days;
      }
      var j = await api.userActivity.active(args);
      setList(j);
    } catch (err) {
      setListError(err.message || 'Hiba történt');
    } finally {
      setListLoading(false);
    }
  };

  // Sorra kattintás → egy user nézet betöltése
  var openUser = function (uid) {
    setGrantMsg(null); setGrantErr(null);
    setMode('user');
    setQuery(uid);
    lookup({ uid: uid });
  };

  return (
    <div style={{ padding: 20, color: C.text, minHeight: '100vh', background: C.bg }}>
      <h2 style={{ marginTop: 0, color: C.accent }}>👤 User Activity</h2>

      {/* Mód-választó */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[['user', '🔍 Egy user'], ['interval', '📅 Időszak']].map(function (m) {
          var active = mode === m[0];
          return (
            <button key={m[0]} type="button" onClick={function () { setMode(m[0]); }}
              style={{
                padding: '8px 16px', borderRadius: 4, cursor: 'pointer', fontSize: 13, fontWeight: 500,
                border: '1px solid ' + (active ? C.accent : C.border),
                background: active ? 'rgba(0,212,255,0.12)' : 'transparent',
                color: active ? C.accent : C.muted,
              }}>{m[1]}</button>
          );
        })}
      </div>

      {/* Egy user kereső */}
      {mode === 'user' && (
        <div style={{ marginBottom: 20, position: 'relative' }}>
          <form onSubmit={handleSearch} style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <input
              type="text" value={query} onChange={function(e) { onQueryChange(e.target.value); }}
              placeholder="Email vagy UID... (fuzzy email keresés ha tartalmaz @-t)"
              style={Object.assign({}, inputStyle, { flex: 1, minWidth: 280 })}
              autoComplete="off"
            />
            <button type="submit" style={btnStyle('primary')} disabled={loading}>
              {loading ? 'Keresés...' : 'Keresés'}
            </button>
          </form>
          {/* 🆕 Fuzzy email javaslatok */}
          {suggestions.length > 0 && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 4, background: '#141932', border: '1px solid #252b4a', borderRadius: 4, zIndex: 10, maxHeight: 320, overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.4)' }}>
              <div style={{ padding: '6px 10px', fontSize: 11, color: '#8b92a8', borderBottom: '1px solid #252b4a' }}>
                {suggestions.length} egyezés{searchBusy ? ' · keresés…' : ''}
              </div>
              {suggestions.map(function(s) {
                return (
                  <div key={s.uid}
                    onClick={function() { setQuery(s.email); setSuggestions([]); lookup({ uid: s.uid }); }}
                    style={{ padding: '8px 10px', cursor: 'pointer', borderBottom: '1px solid #252b4a', fontSize: 13 }}
                    onMouseEnter={function(e) { e.currentTarget.style.background = '#1a2045'; }}
                    onMouseLeave={function(e) { e.currentTarget.style.background = 'transparent'; }}>
                    <div style={{ fontWeight: 600 }}>{s.email}</div>
                    <div style={{ fontSize: 11, color: '#8b92a8' }}>
                      UID: {s.uid.substring(0, 16)}…
                      {s.lastSignInTime && ' · utolsó login: ' + new Date(s.lastSignInTime).toLocaleDateString('hu-HU')}
                      {s.disabled && ' · 🚫 disabled'}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Időszakos lista */}
      {mode === 'interval' && (
        <div style={{ marginBottom: 20 }}>
          <form onSubmit={handleListActive} style={{ marginBottom: 16, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>Utolsó X nap</div>
              <div style={{ display: 'flex', gap: 6 }}>
                {[7, 14, 30, 90].map(function (d) {
                  var sel = !fromDate && !toDate && days === d;
                  return (
                    <button type="button" key={d}
                      onClick={function () { setFromDate(''); setToDate(''); setDays(d); }}
                      style={{
                        padding: '6px 12px', borderRadius: 4, cursor: 'pointer', fontSize: 12,
                        border: '1px solid ' + (sel ? C.accent : C.border),
                        background: sel ? 'rgba(0,212,255,0.12)' : 'transparent',
                        color: sel ? C.accent : C.muted,
                      }}>{d} nap</button>
                  );
                })}
              </div>
            </div>
            <div>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>vagy tól</div>
              <input type="date" value={fromDate} onChange={function (e) { setFromDate(e.target.value); }} style={inputStyle} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>ig</div>
              <input type="date" value={toDate} onChange={function (e) { setToDate(e.target.value); }} style={inputStyle} />
            </div>
            <button type="submit" style={btnStyle('primary')} disabled={listLoading}>
              {listLoading ? 'Listázás...' : 'Listázás'}
            </button>
          </form>

          {listError && (
            <div style={{ background: '#3a1f1f', border: '1px solid ' + C.danger, padding: 12, borderRadius: 4, marginBottom: 16, color: C.danger }}>
              ⚠️ {listError}
            </div>
          )}

          {list && (
            <div style={{ background: C.panel, padding: 16, borderRadius: 6, border: '1px solid ' + C.border, overflowX: 'auto' }}>
              <div style={{ marginBottom: 12, fontSize: 13, color: C.muted }}>
                <strong style={{ color: C.accent, fontSize: 18 }}>{list.total != null ? list.total : list.returned}</strong> aktív user
                {list.capped ? <span> · az első <strong style={{ color: C.text }}>{list.returned}</strong> látszik (állíts szűkebb időszakot a teljes listához)</span> : ''}
                <span style={{ marginLeft: 12 }}>
                  {Object.keys(list.byPlatform).sort().map(function (p) {
                    return <span key={p} style={{ marginRight: 10 }}>{p}: <strong style={{ color: C.text }}>{list.byPlatform[p]}</strong></span>;
                  })}
                </span>
              </div>
              {list.users.length === 0 ? (
                <div style={{ color: C.muted, fontSize: 13 }}>Nincs aktív user ebben az időszakban.</div>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid ' + C.border, color: C.muted, textAlign: 'left' }}>
                      <th style={{ padding: '8px 6px' }}>Utolsó aktivitás</th>
                      <th style={{ padding: '8px 6px' }}>Email</th>
                      <th style={{ padding: '8px 6px' }}>Város</th>
                      <th style={{ padding: '8px 6px' }}>Nyelv</th>
                      <th style={{ padding: '8px 6px' }}>Platform</th>
                      <th style={{ padding: '8px 6px', textAlign: 'right' }}>POI</th>
                      <th style={{ padding: '8px 6px' }}>Regisztrált</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.users.map(function (u) {
                      return (
                        <tr key={u.uid} onClick={function () { openUser(u.uid); }}
                          style={{ borderBottom: '1px solid ' + C.border, cursor: 'pointer' }}
                          title="Kattints a részletekért">
                          <td style={{ padding: '6px', whiteSpace: 'nowrap', color: C.muted }}>{formatDate(u.lastPositionAt)}</td>
                          <td style={{ padding: '6px', color: C.text }}>{u.email || <code style={{ fontSize: 10, color: C.muted }}>{u.uid.substring(0, 10)}…</code>}</td>
                          <td style={{ padding: '6px', color: C.muted }}>{u.lastCity || '—'}</td>
                          <td style={{ padding: '6px', color: C.muted }}>{u.appLanguage || '—'}</td>
                          <td style={{ padding: '6px' }}>
                            {u.platform ? (
                              <span style={{
                                padding: '2px 6px', borderRadius: 4, fontSize: 10, fontWeight: 600,
                                background: u.platform === 'ios' ? '#1e3a5f' : '#1f3a1e',
                                color: u.platform === 'ios' ? '#7dd3fc' : '#86efac',
                              }}>{u.platform}</span>
                            ) : '—'}
                          </td>
                          <td style={{ padding: '6px', textAlign: 'right', fontWeight: 'bold', color: u.poiBalance > 0 ? C.success : C.muted }}>{u.poiBalance}</td>
                          <td style={{ padding: '6px', whiteSpace: 'nowrap', color: C.muted }}>{formatDate(u.createdAt)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              <div style={{ marginTop: 8, fontSize: 11, color: C.muted }}>
                💡 Aktivitás = utolsó ismert pozíció ideje (lastPositionAt). Kattints egy sorra a teljes user-aktivitásért.
              </div>
            </div>
          )}
        </div>
      )}

      {/* 🆕 Törlés eredménye — a user panel ilyenkor már eltűnt */}
      {mode === 'user' && delDone && (
        <div style={{
          background: delDone.success ? '#14281c' : '#3a2a1f',
          border: '1px solid ' + (delDone.success ? C.success : C.warning),
          padding: 12, borderRadius: 4, marginBottom: 16, fontSize: 13, color: C.text,
        }}>
          <b>{delDone.success ? '✅ User törölve' : '⚠️ Részlegesen törölve'}</b>
          {delDone.email ? ' — ' + delDone.email : ''}
          <div style={{ fontSize: 12, color: C.muted, marginTop: 6, lineHeight: 1.6 }}>
            Bejelentkezési fiók: {delDone.deleted.authAccount ? 'törölve' : 'nem volt / nem sikerült'} ·
            {' '}User dokumentum: {delDone.deleted.userDoc ? 'törölve' : 'nem sikerült'} ·
            {' '}POI-tranzakció: {delDone.deleted.poiTransactions} db ·
            {' '}Vásárlási rekord: {delDone.deleted.iapTransactions} db ·
            {' '}Admin-jegyzet: {delDone.deleted.adminNotes} db
            {delDone.kept && delDone.kept.affiliateConversions ? (
              <div style={{ marginTop: 4 }}>
                Megmaradt {delDone.kept.affiliateConversions} affiliate konverzió (pénzügyi rekord).
              </div>
            ) : null}
          </div>
          {delDone.errors && delDone.errors.length > 0 && (
            <div style={{ color: C.danger, fontSize: 12, marginTop: 8 }}>
              Hibák: {delDone.errors.join(' | ')}
              <div style={{ color: C.muted, marginTop: 2 }}>
                A törlés újrafuttatható — a már törölt részeket kihagyja.
              </div>
            </div>
          )}
          <button type="button" onClick={function () { setDelDone(null); }}
            style={Object.assign({}, btnStyle(), { marginTop: 10 })}>Bezárás</button>
        </div>
      )}

      {mode === 'user' && error && (
        <div style={{ background: '#3a1f1f', border: '1px solid ' + C.danger, padding: 12, borderRadius: 4, marginBottom: 16, color: C.danger }}>
          ⚠️ {error}
        </div>
      )}

      {mode === 'user' && data && (
        <div style={{ background: C.panel, padding: 16, borderRadius: 6, border: '1px solid ' + C.border, marginBottom: 16 }}>
          <h3 style={{ marginTop: 0, color: C.accent, fontSize: 15 }}>📥 Teljes anyag letöltése (Excel)</h3>
          <div style={{ fontSize: 12, color: C.muted, marginBottom: 12 }}>
            Egy .xlsx 5 munkalappal: Összefoglaló · POI-használat · Vásárlások · Narrációk · Trace.
          </div>

          <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
            <label style={{ fontSize: 12, color: C.muted }}>Időszak:</label>
            <select value={exportDays} onChange={function(e) { setExportDays(parseInt(e.target.value, 10)); setExportPreview(null); }}
              style={inputStyle}>
              <option value={7}>utolsó 7 nap</option>
              <option value={30}>utolsó 30 nap</option>
              <option value={90}>utolsó 90 nap</option>
              <option value={365}>utolsó 1 év</option>
            </select>

            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: C.muted, cursor: 'pointer' }}>
              <input type="checkbox" checked={exportTrace} onChange={function(e) { setExportTrace(e.target.checked); }}
                style={{ accentColor: C.accent }} />
              Trace logok is (lassabb)
            </label>

            <button onClick={loadExportPreview} disabled={exportBusy} style={btnStyle()}>
              {exportBusy === 'preview' ? 'Számolás…' : '🔍 Mi lesz benne?'}
            </button>
            <button onClick={downloadExport} disabled={exportBusy} style={btnStyle('primary')}>
              {exportBusy === 'download' ? 'Készítés… (eltarthat 1-2 percig)' : '📥 Letöltés Excelben'}
            </button>
          </div>

          {exportPreview && (
            <div style={{ fontSize: 12, color: C.text, background: C.bg, border: '1px solid ' + C.border, borderRadius: 4, padding: 10, marginBottom: 8 }}>
              <b>{exportPreview.counts.poiTx}</b> POI-tranzakció (ebből <b>{exportPreview.counts.consumes}</b> felhasználás)
              {' · '}<b>{exportPreview.counts.iapTx}</b> vásárlás
              {' · '}narráció-keresés <b>{exportPreview.counts.narrationLookups}</b> tételre
              {exportTrace && <> · trace <b>{exportPreview.counts.traceNarrations}</b> narrációra</>}
              <div style={{ color: C.muted, marginTop: 4 }}>
                Első aktivitás: {exportPreview.firstActivity || '—'} · Utolsó: {exportPreview.lastActivity || '—'}
              </div>
            </div>
          )}

          {exportMsg && (
            <div style={{ fontSize: 12, color: exportMsg.ok ? C.success : C.danger }}>
              {exportMsg.ok ? '✅ ' : '⚠️ '}{exportMsg.text}
            </div>
          )}

          <div style={{ fontSize: 11, color: C.muted, marginTop: 8, lineHeight: 1.5 }}>
            ℹ️ A narrációkban nincs user-azonosító, ezért a POI-tranzakciókhoz párosítjuk őket
            POI-név / koordináta + ±10 perc időablak alapján — a táblázat „Biztonság" oszlopa
            mutatja, mennyire erős az egyezés. A trace-logok a Google-nál 30 napig élnek,
            ennél régebbi időszakra a Trace lap üres marad.
          </div>
        </div>
      )}

      {mode === 'user' && data && (
        <div style={{ display: 'grid', gridTemplateColumns: '380px 1fr', gap: 16 }}>
          {/* User info panel */}
          <div style={{ background: C.panel, padding: 16, borderRadius: 6, border: '1px solid ' + C.border }}>
            <h3 style={{ marginTop: 0, color: C.accent, fontSize: 15 }}>📇 User Info</h3>

            <Field label="UID" value={<code style={{ fontSize: 11, color: C.muted }}>{data.uid}</code>} />

            {data.auth && (
              <div>
                <Field label="Email" value={data.auth.email} />
                <Field label="Display name" value={data.auth.displayName} />
                <Field label="Email verified" value={data.auth.emailVerified ? '✅ Igen' : '❌ Nem'} />
                <Field label="Auth providers" value={(data.auth.providers || []).join(', ')} />
                <Field label="Account created" value={formatDate(data.auth.creationTime)} />
                <Field label="Last sign-in" value={formatDate(data.auth.lastSignInTime)} />
              </div>
            )}

            <hr style={{ border: 'none', borderTop: '1px solid ' + C.border, margin: '12px 0' }} />

            <Field label="App language" value={data.user.appLanguage} />
            <Field label="Platform" value={data.user.fcmPlatform} />
            <Field label="POI Balance" value={
              <span style={{ color: data.user.poiBalance > 0 ? C.success : C.warning, fontWeight: 'bold', fontSize: 16 }}>
                {data.user.poiBalance}
              </span>
            } />

            {/* 🆕 POI jóváírás / levonás */}
            <div style={{ margin: '8px 0 12px', padding: 10, background: C.bg, border: '1px solid ' + C.border, borderRadius: 6 }}>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 6 }}>± POI jóváírás / levonás (egyszeri)</div>
              <div style={{ display: 'flex', gap: 6, marginBottom: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                {[5, 15, 50, -5, -15, -50].map(function (n) {
                  var neg = n < 0;
                  var sel = grantAmount === n;
                  return (
                    <button type="button" key={n} onClick={function () { setGrantAmount(n); }}
                      style={{
                        padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 12,
                        border: '1px solid ' + (sel ? (neg ? C.danger : C.accent) : C.border),
                        background: sel ? (neg ? 'rgba(239,68,68,0.12)' : 'rgba(0,212,255,0.12)') : 'transparent',
                        color: sel ? (neg ? C.danger : C.accent) : C.muted,
                      }}>{n > 0 ? '+' : ''}{n}</button>
                  );
                })}
                <input type="number" value={grantAmount}
                  onChange={function (e) { setGrantAmount(parseInt(e.target.value, 10) || 0); }}
                  style={Object.assign({}, inputStyle, { width: 64 })} />
                {/* Nullázás: pontosan a jelenlegi egyenleget vonja le */}
                <button type="button"
                  onClick={function () { setGrantAmount(-(data.user.poiBalance || 0)); }}
                  disabled={!data.user.poiBalance}
                  title={'Az egyenleg (' + (data.user.poiBalance || 0) + ' POI) nullázása'}
                  style={{
                    padding: '4px 10px', borderRadius: 4, fontSize: 12,
                    cursor: data.user.poiBalance ? 'pointer' : 'default',
                    border: '1px solid ' + C.border, background: 'transparent',
                    color: data.user.poiBalance ? C.warning : C.border,
                  }}>Nullázás</button>
              </div>
              <input type="text" value={grantNote}
                onChange={function (e) { setGrantNote(e.target.value); }}
                placeholder="megjegyzés (opcionális)"
                style={Object.assign({}, inputStyle, { width: '100%', boxSizing: 'border-box', marginBottom: 6 })} />
              <button type="button" onClick={grantPoi} disabled={granting || !grantAmount}
                style={Object.assign({}, btnStyle(grantAmount < 0 ? 'danger' : 'primary'),
                  { width: '100%', opacity: (granting || !grantAmount) ? 0.6 : 1,
                    background: grantAmount < 0 ? C.danger : undefined,
                    color: grantAmount < 0 ? '#fff' : undefined })}>
                {granting
                  ? (grantAmount < 0 ? 'Levonás...' : 'Jóváírás...')
                  : (grantAmount < 0
                    ? ('Levonás: ' + grantAmount + ' POI → ' + Math.max(0, (data.user.poiBalance || 0) + grantAmount))
                    : ('Jóváírás: +' + grantAmount + ' POI'))}
              </button>
              {grantAmount < 0 && (
                <div style={{ fontSize: 10, color: C.muted, marginTop: 5, lineHeight: 1.4 }}>
                  A levonás nem viheti 0 alá az egyenleget — a szerver elutasítja, ha többet vonnál le,
                  mint amennyi van. A művelet bekerül a tranzakció-naplóba <code>admin_deduct</code> forrással.
                </div>
              )}
              {grantMsg && <div style={{ color: C.success, fontSize: 12, marginTop: 6 }}>{grantMsg}</div>}
              {grantErr && <div style={{ color: C.danger, fontSize: 12, marginTop: 6 }}>⚠️ {grantErr}</div>}
            </div>

            <Field label="Subscription" value={data.user.subscriptionStatus} />
            <Field label="Total POIs (passport)" value={data.user.passportTotalPois} />
            <Field label="Cities visited" value={data.user.passportCities} />
            <Field label="Last position" value={
              data.user.lastLat != null && data.user.lastLon != null
                ? data.user.lastLat.toFixed(4) + ', ' + data.user.lastLon.toFixed(4) : '—'
            } />
            <Field label="Last position at" value={formatDate(data.user.lastPositionAt)} />

            {/* 🆕 Veszélyzóna — user végleges törlése */}
            <div style={{ marginTop: 16, padding: 10, background: '#2a1416', border: '1px solid ' + C.danger, borderRadius: 6 }}>
              <div style={{ fontSize: 11, color: C.danger, fontWeight: 'bold', marginBottom: 6 }}>
                ⚠️ Veszélyzóna — user végleges törlése
              </div>

              {!delPreview ? (
                <>
                  <div style={{ fontSize: 11, color: C.muted, marginBottom: 8, lineHeight: 1.5 }}>
                    A törlés <b style={{ color: C.text }}>nem vonható vissza</b>. Előbb megmutatom,
                    pontosan mi törlődik és mi marad meg.
                  </div>
                  <button type="button" onClick={loadDeletePreview} disabled={delBusy}
                    style={Object.assign({}, btnStyle(), { width: '100%', color: C.danger, borderColor: C.danger })}>
                    {delBusy ? 'Ellenőrzés...' : '🔍 Mi törlődne?'}
                  </button>
                </>
              ) : (
                <>
                  <div style={{ fontSize: 11, color: C.text, marginBottom: 8, lineHeight: 1.6 }}>
                    <div style={{ color: C.danger, fontWeight: 'bold' }}>Törlődik:</div>
                    <div>• Bejelentkezési fiók: {delPreview.willDelete.authAccount ? 'igen' : 'nincs ilyen'}</div>
                    <div>• User dokumentum: {delPreview.willDelete.userDoc ? 'igen' : 'nincs ilyen'}</div>
                    <div>• POI-tranzakció: <b>{delPreview.willDelete.poiTransactions}</b> db</div>
                    <div>• Vásárlási rekord: <b>{delPreview.willDelete.iapTransactions}</b> db</div>
                    <div>• Admin-jegyzet: <b>{delPreview.willDelete.adminNotes}</b> db</div>
                    {delPreview.poiBalance != null && (
                      <div>• Elvesző egyenleg: <b>{delPreview.poiBalance}</b> POI</div>
                    )}

                    <div style={{ color: C.success, fontWeight: 'bold', marginTop: 8 }}>Megmarad:</div>
                    <div>• Affiliate konverzió: <b>{delPreview.willKeep.affiliateConversions}</b> db</div>
                    <div style={{ color: C.muted, fontSize: 10, lineHeight: 1.4, marginTop: 2 }}>
                      Pénzügyi rekord — a partner jutaléka ezen alapul, ezért nem töröljük.
                      A narráció- és GNSS-adatok nem tartalmaznak user-azonosítót, így ott nincs mit törölni.
                      A kimenő levelek naplója (email cím) szintén megmarad.
                    </div>
                  </div>

                  <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>
                    Megerősítés — írd be: <b style={{ color: C.text }}>{delPreview.email || delPreview.uid}</b>
                  </div>
                  <input type="text" value={delConfirm}
                    onChange={function (e) { setDelConfirm(e.target.value); }}
                    placeholder={delPreview.email || delPreview.uid}
                    style={Object.assign({}, inputStyle, { width: '100%', boxSizing: 'border-box', marginBottom: 6 })} />

                  <div style={{ display: 'flex', gap: 6 }}>
                    <button type="button" onClick={function () { setDelPreview(null); setDelErr(null); }}
                      disabled={delBusy}
                      style={Object.assign({}, btnStyle(), { flex: 1 })}>Mégse</button>
                    <button type="button" onClick={doDeleteUser} disabled={delBusy || !delConfirm.trim()}
                      style={Object.assign({}, btnStyle(), {
                        flex: 2, background: C.danger, color: '#fff',
                        opacity: (delBusy || !delConfirm.trim()) ? 0.5 : 1,
                      })}>
                      {delBusy ? 'Törlés...' : '🗑️ Végleges törlés'}
                    </button>
                  </div>
                </>
              )}

              {delErr && <div style={{ color: C.danger, fontSize: 12, marginTop: 6 }}>⚠️ {delErr}</div>}
            </div>

            <hr style={{ border: 'none', borderTop: '1px solid ' + C.border, margin: '12px 0' }} />

            <h4 style={{ color: C.accent, fontSize: 13, margin: '8px 0' }}>📊 Activity summary</h4>
            <Field label="Total POIs consumed" value={
              <span style={{ color: C.warning, fontWeight: 'bold' }}>{data.summary.totalConsume}</span>
            } />
            <Field label="Total credits added" value={
              <span style={{ color: C.success, fontWeight: 'bold' }}>{data.summary.totalRecharge}</span>
            } />
            {data.summary.iapTotal > 0 && (
              <Field label="IAP vásárlások" value={
                <span style={{ color: C.purple, fontWeight: 'bold' }}>
                  {data.summary.iapTotal} db · ${data.summary.iapTotalUsd.toFixed(2)}
                </span>
              } />
            )}
            <Field label="Net balance change" value={
              <span style={{ color: (data.summary.totalRecharge - data.summary.totalConsume) >= 0 ? C.success : C.danger, fontWeight: 'bold' }}>
                {data.summary.totalRecharge - data.summary.totalConsume >= 0 ? '+' : ''}{data.summary.totalRecharge - data.summary.totalConsume}
              </span>
            } />
            <Field label="First activity" value={formatDate(data.summary.firstActivity)} />
            <Field label="Last activity" value={formatDate(data.summary.lastActivity)} />

            {/* 🆕 Sprint 4: Admin jegyzetek */}
            <div style={{ marginTop: 16, padding: 10, background: C.panelDark || '#0f1428', borderRadius: 4, border: '1px solid ' + C.border }}>
              <div style={{ fontSize: 12, color: C.accent, marginBottom: 6, fontWeight: 600 }}>📝 Admin jegyzetek ({notes.length})</div>
              {notes.length > 0 && (
                <div style={{ maxHeight: 200, overflowY: 'auto', marginBottom: 8 }}>
                  {notes.map(function(n) {
                    return (
                      <div key={n.id} style={{ padding: '6px 8px', marginBottom: 4, background: C.panel, borderRadius: 4, fontSize: 12, position: 'relative' }}>
                        <div style={{ color: C.text, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{n.note}</div>
                        <div style={{ fontSize: 10, color: C.muted, marginTop: 4 }}>
                          {n.created_at} · {n.created_by || 'admin'}
                          <span onClick={function(){ delNote(n.id); }} style={{ float: 'right', cursor: 'pointer', color: C.danger }}>✕</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              <textarea value={newNote} onChange={function(e){ setNewNote(e.target.value); }}
                placeholder={'új jegyzet… (Pl. pénzvisszafizetés intézve 2026-06-01)'}
                style={Object.assign({}, inputStyle, { width: '100%', boxSizing: 'border-box', marginBottom: 4, minHeight: 50, fontFamily: 'inherit', fontSize: 12 })} />
              <button type="button" onClick={addNote} disabled={noteBusy || !newNote.trim()}
                style={Object.assign({}, btnStyle('primary'), { width: '100%', opacity: (noteBusy || !newNote.trim()) ? 0.6 : 1, fontSize: 12 })}>
                {noteBusy ? 'Mentés…' : '+ Jegyzet'}
              </button>
            </div>

            {/* 🆕 Sprint 4: Direkt push küldés */}
            <div style={{ marginTop: 12, padding: 10, background: C.panelDark || '#0f1428', borderRadius: 4, border: '1px solid ' + C.border }}>
              <div style={{ fontSize: 12, color: C.accent, marginBottom: 6, fontWeight: 600 }}>🔔 Direkt push küldés</div>
              <input value={pushTitle} onChange={function(e){ setPushTitle(e.target.value); }}
                placeholder="Cím"
                style={Object.assign({}, inputStyle, { width: '100%', boxSizing: 'border-box', marginBottom: 4, fontSize: 12 })} />
              <textarea value={pushBody} onChange={function(e){ setPushBody(e.target.value); }}
                placeholder="Üzenet törzs"
                style={Object.assign({}, inputStyle, { width: '100%', boxSizing: 'border-box', marginBottom: 4, minHeight: 50, fontFamily: 'inherit', fontSize: 12 })} />
              <input value={pushAction} onChange={function(e){ setPushAction(e.target.value); }}
                placeholder={'Action (opc., pl. referral, profile)'}
                style={Object.assign({}, inputStyle, { width: '100%', boxSizing: 'border-box', marginBottom: 4, fontSize: 12 })} />
              <button type="button" onClick={sendDirectPush} disabled={pushBusy || !pushTitle.trim() || !pushBody.trim()}
                style={Object.assign({}, btnStyle('primary'), { width: '100%', opacity: (pushBusy || !pushTitle.trim() || !pushBody.trim()) ? 0.6 : 1, fontSize: 12 })}>
                {pushBusy ? 'Küldés…' : '🔔 Push küldés'}
              </button>
              {pushMsg && <div style={{ fontSize: 11, marginTop: 6, color: pushMsg.startsWith('✅') ? C.success : C.danger }}>{pushMsg}</div>}
            </div>
          </div>

          {/* Transactions table */}
          <div style={{ background: C.panel, padding: 16, borderRadius: 6, border: '1px solid ' + C.border, overflowX: 'auto' }}>
            <h3 style={{ marginTop: 0, color: C.accent, fontSize: 15 }}>
              📋 Tranzakciók ({data.transactions.length})
            </h3>
            {data.transactions.length === 0 ? (
              <div style={{ color: C.muted, fontSize: 13 }}>Nincs tranzakció.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid ' + C.border, color: C.muted, textAlign: 'left' }}>
                    <th style={{ padding: '8px 6px' }}>Időpont</th>
                    <th style={{ padding: '8px 6px' }}>Típus</th>
                    <th style={{ padding: '8px 6px', textAlign: 'right' }}>Δ POI</th>
                    <th style={{ padding: '8px 6px' }}>Részletek</th>
                    <th style={{ padding: '8px 6px' }}>Platform</th>
                    <th style={{ padding: '8px 6px' }}>Forrás</th>
                  </tr>
                </thead>
                <tbody>
                  {data.transactions.map(function(t) {
                    var isConsume = t.amount < 0;
                    var isIap = t.origin === 'iap_transactions' || (t.source && t.source.startsWith('iap_'));
                    var rowBg = isIap ? 'rgba(34, 197, 94, 0.06)' : isConsume ? 'transparent' : 'rgba(168, 85, 247, 0.06)';
                    return (
                      <tr key={t.id} style={{ borderBottom: '1px solid ' + C.border, background: rowBg }}>
                        <td style={{ padding: '6px', whiteSpace: 'nowrap', color: C.muted }}>{formatDate(t.timestamp)}</td>
                        <td style={{ padding: '6px' }}>{sourceLabel(t.source)}</td>
                        <td style={{
                          padding: '6px', textAlign: 'right', fontWeight: 'bold', fontSize: 14,
                          color: isConsume ? C.warning : C.success,
                        }}>
                          {t.amount > 0 ? '+' + t.amount : t.amount}
                        </td>
                        <td style={{ padding: '6px', fontSize: 11, color: C.muted }}>
                          {t.poiName ? t.poiName : ''}
                          {t.productId ? t.productId : ''}
                          {t.priceUsd ? ' ($' + t.priceUsd.toFixed(2) + ')' : ''}
                        </td>
                        <td style={{ padding: '6px' }}>
                          {t.platform ? (
                            <span style={{
                              padding: '2px 6px', borderRadius: 4, fontSize: 10, fontWeight: 600,
                              background: t.platform === 'ios' ? '#1e3a5f' : '#1f3a1e',
                              color: t.platform === 'ios' ? '#7dd3fc' : '#86efac',
                            }}>{t.platform}</span>
                          ) : '—'}
                        </td>
                        <td style={{ padding: '6px', fontSize: 10, color: C.muted }}>
                          {t.origin === 'iap_transactions' ? '💳 IAP' : '📊 POI log'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <div style={{ marginTop: 8, fontSize: 11, color: C.muted }}>
              💡 Két forrás összefűzve: poi_transactions (consume + credit log) és users/transactions (IAP verifikáció). Dedup automatikus.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
